fx.ns("desktop.print", class PrintView extends shared.stage.BaseView {

    constructor(board){
        super(board);

        this.actionBarWidth = 80;
        this.vmargin = 120;
        
        this.spaceBeforeButton = 100;

        this.squareAreaSize = 350;
        this.landscapeAreaWidth = 360;
        this.landscapeAreaHeight = 252;
    }

    update(animate) 
    {
        let screenWidth = this.board.realWidth - this.actionBarWidth;
        let spaceAfterRow = 100;
        let spaceBetweenAreas = 50;

        let numberElementsPerRow =  3;
        if (screenWidth > 1400)
            spaceBetweenAreas = 80;

        if (screenWidth < 1200)
            numberElementsPerRow =  2;

        if (screenWidth < 850)
            numberElementsPerRow =  1;
        
        let childs = this.board.allChilds;
        let areas = childs.filter( (child) => child instanceof shared.stage.PrintArea);
        let buttons = childs.filter( (child) => !(child instanceof shared.stage.PrintArea));


        let childXPos = 0;
        let yPos = this.vmargin;

        let rows = [];
        let currentRow = [];
        
        for (let i = 0; i < areas.length; i++) 
        {
            let area = areas[i];
            
            let orientation = (area.width() == area.height()) ? "square" : (area.width() > area.height() ? "landscape" : "portrait");
            
            let areaWidth = (orientation == "square") ? this.squareAreaSize : ((orientation == "landscape") ? this.landscapeAreaWidth : this.landscapeAreaHeight);
                
            currentRow.rowWidth = (currentRow.rowWidth ? currentRow.rowWidth : 0) + areaWidth;
            let areaScale = areaWidth / area.width() ;

            currentRow.push({ area : area, scale : areaScale} );
            
            if (currentRow.length >= numberElementsPerRow || i == areas.length - 1)
            {
                // let's calculate margin to have row centered
                let totalWidth = currentRow.rowWidth + (currentRow.length-1) * spaceBetweenAreas; // espace entre chaque area 
                currentRow.margin = (screenWidth - totalWidth) / 2 / areaScale;

                rows.push( currentRow );
                currentRow = [];
            }
        }


        let lastArea;
        for (let i = 0; i < rows.length; i++) 
        {
            let row = rows.getItemAt(i);
            let maxHeight = 0;
            childXPos = row.margin;
            let allHorizontal = true;
            for (let j = 0; j < row.length; j++) 
            {
                let areaItem = row.getItemAt(j);

                let yPosition = yPos;
                let orientation = (areaItem.area.width() == areaItem.area.height()) ? "square" : (areaItem.area.width() > areaItem.area.height() ? "landscape" : "portrait");
                if (orientation == "landscape")
                    yPosition += (this.landscapeAreaWidth - this.landscapeAreaHeight) / 2; // center vertically landscape points

                allHorizontal = allHorizontal && (orientation == "landscape");
                
                this.applyPosition(areaItem.area, { scale : areaItem.scale, x : childXPos, y :  yPosition }, (areaItem.area instanceof shared.stage.PrintArea));

                childXPos += (areaItem.area.realWidth) + spaceBetweenAreas/ areaItem.area.scale;
                maxHeight = Math.max(maxHeight, areaItem.area.realHeight);

                lastArea = areaItem;
            }

            yPos += maxHeight + (allHorizontal ? 1.7 : 1.2) *spaceAfterRow;
            
        }

        if (lastArea)
            yPos = yPos * lastArea.area.scale;
        
        for (let i = 0; i < buttons.length; i++) 
        {
            let button = buttons.getItemAt(i);
            childXPos = (screenWidth- button.realWidth)/2 ;

            if (button instanceof fx.components.Card)
                button.toggle( areas.length == 0)
            
            // hidden, the card still takes its height : kept at the top so it adds no space after the prints
            let y = (button instanceof fx.components.Card) ? this.vmargin : yPos;
            this.applyPosition(button, { scale : 1, x : childXPos, y :  y },false);
        }
        
/*
        for (let i = 0; i < areas.length; i++) 
        {
            let area = areas[i];
            
            area.show();
            
            childScale = childWidth / child.width();

            if (numElementOnCurrentline > numberElementsPerLine)
            {
                numElementOnCurrentline = 1;
                yPos += child.realHeight *  childScale  +spaceAfterPage;
            }

            childXPos = sideMargin/ childScale + marginOffset/ childScale + ( (numElementOnCurrentline-1) * (child.realWidth + actionWidth/ childScale));
            childYPos = yPos / childScale;
            previousPage = child;
        
            numElementOnCurrentline++;
                
            this.applyPosition(child, { scale : childScale, x : childXPos, y :  childYPos }, (child instanceof shared.stage.PrintArea));
        }*/

        // the card has its own button when there is no print yet
        if (this.board._addPhotosFab)
            this.board._addPhotosFab.toggle( areas.length > 0 );

        this.delay(this.scroll, animate ? 250 : 0);
    }

    select(area, animate)
    {
        let position = this.getPosition(area);

        if (position)
        {
            let yPos = (position.y * position.scale) - (this.board.realHeight - area.realHeight*position.scale) / 2;
            this.board.scrollableContent.scroll( yPos, animate, "vertical");
        }
    }

    scroll()
    {
        let viewPort = { top : Math.max(0,this.board.scrollPosition - this.board.realHeight), bottom : this.board.scrollPosition  + 2*this.board.realHeight };
        this._areas = [];

        for (let i = 0; i < this.board._editableAreas.length; i++)
        {
            let area = this.board._editableAreas[i];

            if (area.dragActive)
                continue;

            let position = this.getPosition( area );
            
            if (!position)
                continue;
                
            let load = !( position.y*position.scale  > viewPort.bottom  || (position.y*position.scale + fx.dom.height(area.node) * position.scale) < viewPort.top );
            this._areas.push({area : area, load : load});
        }

        this.delay(this._loadUnload, 50);
    }

    _loadUnload()
    {
        for (let i = 0; i < this._areas.length; i++)
        {
            let item = this._areas.getItemAt(i);
            if (item.load)
                item.area.load();
            else
                item.area.unload();
        }

    }

});
